import { Skeleton } from "@mui/material";

import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getRequisitionCertificates } from "../../../store/recruitment/actions";
import ReactPaginate from "react-paginate";
import {
  List,
  ListItem,
  ListItemText,
  Divider,
  ListItemAvatar,
  Avatar,
} from "@mui/material";
import ListSkeleton from "../../common/components/ListSkeleton";
const RequisitionCertificate = (props) => {
  const { requisitionId, requisitionCertificates, getRequisitionCertificates } =
    props;
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    getRequisitionCertificates(requisitionId, setIsLoading);
  }, [requisitionId]);

  const getNo = (idToSearch) =>
    requisitionCertificates.findIndex(({ id }) => id === idToSearch);
  return (
    <>
      {!isLoading && !!requisitionCertificates.length && (
        <div className="col-lg-12 mt-3">
          <strong>Required Certificates</strong>
          <List
            className="mt-2"
            sx={{
              borderRadius: "8px",
              border: `1px solid #c8c6c6`,
              backgroundColor: "#f9f9f9",
            }}
            dense
          >
            {requisitionCertificates.map((row, index) => (
              <React.Fragment key={row.id}>
                <ListItem dense>
                  <ListItemAvatar>
                    <Avatar
                      style={{
                        fontSize: "16px",
                        border: "1px solid #c8c6c6",
                      }}
                      className="bg-white text-dark "
                    >
                      {getNo(row.id) + 1}
                    </Avatar>
                  </ListItemAvatar>

                  <ListItemText
                    primary={
                      <span className={`${"font-weight-light"}`}>
                        {row.certificate && row.certificate.name}
                      </span>
                    }
                    secondary={
                      <>
                        <span
                          className={`${"font-weight-light badge badge-primary"}`}
                        >
                          {row.certificate &&
                            row.certificate.certificateField &&
                            row.certificate.certificateField.name}
                        </span>
                      </>
                    }
                  />
                </ListItem>

                {requisitionCertificates.length > index + 1 && <Divider />}
              </React.Fragment>
            ))}
          </List>
        </div>
      )}

      {isLoading && (
        <div className="col-lg-12 mt-3">
          <ListSkeleton />
        </div>
      )}
    </>
  );
};

const mapStateToProps = ({ loading, requisitionCertificates }) => {
  return {
    loading,
    requisitionCertificates,
  };
};
export default connect(mapStateToProps, {
  getRequisitionCertificates,
})(RequisitionCertificate);
